import { AppShell as MantineAppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Aside } from '../Aside';
import { Footer } from '../Footer';
import { SideBar } from '../SideBar';
import { TopBar } from '../TopBar';
import styles from './AppShell.module.css';

export const AppShell: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [tasksOpened, { toggle: toggleTasks }] = useDisclosure(false);

  return (
    <MantineAppShell
      header={{ height: 55 }}
      navbar={{
        width: 70,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      aside={{
        width: 400,
        breakpoint: 'sm',
        collapsed: { mobile: !tasksOpened, desktop: !tasksOpened },
      }}
    >
      <MantineAppShell.Header withBorder={false}>
        <TopBar
          toggleMobile={toggleMobile}
          toggleDesktop={toggleDesktop}
          toggleTasks={toggleTasks}
        />
      </MantineAppShell.Header>
      <MantineAppShell.Navbar withBorder={false}>
        <SideBar />
      </MantineAppShell.Navbar>
      <MantineAppShell.Aside withBorder={false}>
        <Aside />
      </MantineAppShell.Aside>
      <MantineAppShell.Main className={styles.appShellMain}>
        {children}
        <Footer />
      </MantineAppShell.Main>
    </MantineAppShell>
  );
};
